import ModalDel from './modal-delete.component'

export default ModalDel